var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component, Fragment } from "react";
import browserImageSize from "browser-image-size";
import { injectIntl, FormattedMessage } from "@irati/utils/lang";
import addTrophy from "@irati/ui/images/trophy-empty.png";
import getBase64 from "@irati/utils/images/getBase64";
import { uploadImage } from "@irati/images/services/image";
import Loading from "@irati/ui/src/Loading";
import TrophyImg from "@irati/ui/src/Trophy";
import StyledDropzone from "./Dropzone";
import { CustomTrophyWrapper, CustomTrophyText } from "./styled";
var MAX_SIZE = 2;
var MAX_SIZE_BYTES = MAX_SIZE * 1024 * 1024;
var CustomTrophy = /** @class */ (function (_super) {
    __extends(CustomTrophy, _super);
    function CustomTrophy(props) {
        var _this = _super.call(this, props) || this;
        _this.handleUpload = function (file) {
            var onUpload = _this.props.onUpload;
            return uploadImage(file).then(function (imgUrl) {
                _this.setState({
                    load: undefined,
                    trophy: imgUrl
                });
                onUpload(imgUrl);
            });
        };
        _this.handleTooSmall = function () {
            var _a = _this.props, formatMessage = _a.formatMessage, setError = _a.setError;
            setError(formatMessage({ id: "platform.fields.trophy.uploadImage.uploadFailed.error" }));
            _this.setState({ load: undefined });
        };
        _this.handleDrop = function (acceptedFile, rejectedFile) {
            var _a = _this.props, setError = _a.setError, formatMessage = _a.formatMessage;
            var dimensions = {
                width: 165,
                height: 165
            };
            if (rejectedFile.length > 0) {
                setError(formatMessage({ id: "platform.fields.trophy.uploadImage.uploadError" }, { maxSize: MAX_SIZE }));
            }
            else {
                return getBase64(acceptedFile[0]).then(function (base64Image) {
                    var load = browserImageSize(base64Image)
                        .then(function (size) {
                        if (size.width < dimensions.width || size.height < dimensions.height) {
                            return _this.handleTooSmall();
                        }
                        return _this.handleUpload(base64Image);
                    });
                    _this.setState({ load: load });
                });
            }
        };
        var trophy = _this.props.trophy;
        _this.state = {
            load: undefined,
            trophy: trophy
        };
        return _this;
    }
    CustomTrophy.prototype.render = function () {
        var _a = this.state, load = _a.load, trophy = _a.trophy;
        var selected = this.props.selected;
        return (React.createElement(StyledDropzone, { className: "trophy-picker-dropzone", name: "benefit_card_img", accept: "image/jpg,image/jpeg,image/png", onDrop: this.handleDrop, multiple: false, maxSize: MAX_SIZE_BYTES },
            React.createElement(CustomTrophyWrapper, { selected: selected },
                React.createElement(Loading, { load: load }),
                trophy && !load &&
                    React.createElement(TrophyImg, { isSet: true, src: trophy }),
                !trophy && !load &&
                    React.createElement(Fragment, null,
                        React.createElement(TrophyImg, { isSet: false, src: addTrophy }),
                        React.createElement(CustomTrophyText, { uppercase: true },
                            React.createElement(FormattedMessage, { id: "platform.fields.trophy.uploadImage.text" }))))));
    };
    CustomTrophy.defaultProps = {
        property: "cardImage",
        id: "uploadImage",
        trophy: undefined
    };
    return CustomTrophy;
}(Component));
export default injectIntl(CustomTrophy);
